import { render, staticRenderFns } from "./FmTabsDemo.vue?vue&type=template&id=924a5c76&scoped=true&"
import script from "./FmTabsDemo.vue?vue&type=script&lang=js&"
export * from "./FmTabsDemo.vue?vue&type=script&lang=js&"
import style0 from "./FmTabsDemo.vue?vue&type=style&index=0&id=924a5c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924a5c76",
  null
  
)

export default component.exports